function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#214080;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M8.18,41.18l2.48-1L12,39.61l-.55-1a18.48,18.48,0,0,1-1.86-5.25l-.24-1.15L5.62,33.77c-1.11.46-2.39,1-3.36,1.39v8.33c.43-.13.87-.27,1.3-.42C4.41,42.78,6.41,41.93,8.18,41.18Zm14.51-20c-1.77-1.15-6.3-1.06-8.36.78S12,26.8,12,29.28a21.77,21.77,0,0,0,.15,2.55A20.66,20.66,0,0,0,17,42.66a21.73,21.73,0,0,0,5.81,4.07l3.27-7.14a15.21,15.21,0,0,1-3.45-2.42,12.88,12.88,0,0,1-2.74-6.25l-.08-1.47s0-.49,0-.89a7.62,7.62,0,0,1,1.3.46l.42.24a14.22,14.22,0,0,1,3.31,3.28l.73,1.32c.73,1.32,1.2,2.16,1.59,2.72a2.62,2.62,0,0,0,.53.68l5.89-5.2-1.13-2a9.93,9.93,0,0,0-.77-1.39C27.54,23.64,25.17,22.76,22.69,21.15Zm43.4,28.54A22.42,22.42,0,0,1,63.67,48l-1-.84c-2.18-1.85-4.67-3.31-6.61-4.79-4-3.08-10.16-9.25-16.39-12.33,0,0,0,0-4-2.42L35,27.11l.21,9.82,2.23,1.39c1.83,1.43,5.26,3.13,7.37,5s5.07,4.78,7.24,6L58.67,54a32.74,32.74,0,0,0,5.92,3.8l1.93.88a31.56,31.56,0,0,1,3.58,1.76.78.78,0,0,1,.25.57,2.33,2.33,0,0,1-.5,1.23,12.54,12.54,0,0,1-2.34,2.77,14.2,14.2,0,0,1-2.25,1.54c-1.79,1-6.93.92-6.93.92H41.08c-5.92,0-9.11,0-13.86,3.49C24,73.39,5.73,92.83,2.34,96.51H14L31.32,78.87c.81-.56,2.9-2.57,4.81-2.61s6,0,6,0l17.17,0c4.32,0,5.59,0,7.88-1.18a32.15,32.15,0,0,0,3.51-2.25l2.86-2.72a13.83,13.83,0,0,0,2.8-3.48,10,10,0,0,0,1.81-5.56,8.86,8.86,0,0,0-2.64-6.23,10.12,10.12,0,0,0-2-1.46m-33.68-1.3a3.91,3.91,0,0,0,2.93-.71A4,4,0,1,0,38.09,45a4,4,0,0,0-1.57,2.59,4,4,0,0,0,.73,3A3.87,3.87,0,0,0,39.85,52.08Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M82.37,44.32S89.18,6.51,66.29-.52L64.78,1.39s15,6.32,9.34,43Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M72.67,44.27s-.23,0-5.58,0c0,0,5-19.85-8.9-28.41l.68-.73S76,18.11,72.67,44.27Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M92.58,44.21s-4.14-16.14,8.36-24.73L100.71,18s-9.66,3.22-15.83,18l-1,8.38Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M85.27,28.94S88,18.07,94.36,13.15l-.46-1.5s-5,1.25-9.58,8.46A39.84,39.84,0,0,1,85.27,28.94Z"
});

var SvgHnIconsFeedBlue = function SvgHnIconsFeedBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHnIconsFeedBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HN_icons_Feed-Blue.00c9f1b6.svg";
export { ForwardRef as ReactComponent };